var G = Object.defineProperty;
var I = (t, e, s) => e in t ? G(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var b = (t, e, s) => (I(t, typeof e != "symbol" ? e + "" : e, s), s);
import { a as F, j as C } from "./jsx-runtime.mjs";
import k, { useState as _, useMemo as P, useCallback as M, useEffect as O } from "react";
import { throttle as D } from "@vavt/util";
import { p as L, e as y } from "./config.mjs";
class B {
  constructor() {
    // 事件池
    b(this, "pools", {});
  }
  // 移除事件监听
  remove(e, s, n) {
    const o = this.pools[e] && this.pools[e][s];
    o && (this.pools[e][s] = o.filter((l) => l !== n));
  }
  // 清空全部事件，由于单一实例，多次注册会被共享内容
  clear(e) {
    this.pools[e] = {};
  }
  // 注册事件监听
  on(e, s) {
    return this.pools[e] || (this.pools[e] = {}), this.pools[e][s.name] || (this.pools[e][s.name] = []), this.pools[e][s.name].push(s.callback), this.pools[e][s.name].includes(s.callback);
  }
  // 触发事件
  emit(e, s, ...n) {
    this.pools[e] || (this.pools[e] = {});
    const o = this.pools[e][s];
    o && o.forEach((l) => {
      try {
        l(...n);
      } catch (i) {
        console.error(`${s} monitor event exception！`, i);
      }
    });
  }
}
const H = new B(), Q = "onSave", Y = "changeCatalogVisible", ee = "changeFullscreen", te = "pageFullscreenChanged", se = "fullscreenChanged", oe = "previewChanged", ne = "htmlPreviewChanged", ae = "catalogVisibleChanged", le = "textareaFocus", ce = "buildFinished", re = "errorCatcher", ie = "replace", de = "uploadImage", ue = "openModals", he = "ctrlZ", pe = "ctrlShiftZ", S = "catalogChanged", U = "pushCatalog", fe = (t, e = "image.png") => {
  const s = t.split(","), n = s[0].match(/:(.*?);/);
  if (n) {
    const d = n[1], o = atob(s[1]);
    let l = o.length;
    const i = new Uint8Array(l);
    for (; l--; )
      i[l] = o.charCodeAt(l);
    return new File([i], e, { type: d });
  }
  return null;
}, Ee = (t) => {
  if (!t)
    return t;
  const e = t.split(`
`), s = ['<span rn-wrapper aria-hidden="true">'];
  return e.forEach(() => {
    s.push("<span></span>");
  }), s.push("</span>"), `<span class="code-block">${t}</span>${s.join("")}`;
}, V = (t) => t.filter((e) => e !== !1).join(" "), j = (t, e) => {
  if (!t || !e)
    return 0;
  const s = t == null ? void 0 : t.getBoundingClientRect();
  if (e === document.documentElement)
    return s.top - e.clientTop;
  const n = e == null ? void 0 : e.getBoundingClientRect();
  return s.top - n.top;
}, ge = () => `${Date.now().toString(36)}${Math.random().toString(36).substring(2)}`, $ = ({
  tocItem: t,
  mdHeadingId: e,
  scrollElement: s,
  onClick: n,
  scrollElementOffsetTop: d = 0
}) => /* @__PURE__ */ F(
  "div",
  {
    className: V([
      `${L}-catalog-link`,
      t.active && `${L}-catalog-active`
    ]),
    onClick: (o) => {
      n && n(o, t), o.stopPropagation();
      const l = e(t.text, t.level, t.index), i = document.getElementById(l), u = s instanceof Element ? s : document.querySelector(s);
      if (i && u) {
        let c = i.offsetParent, h = i.offsetTop;
        if (u.contains(c))
          for (; c && u != c; )
            h += c == null ? void 0 : c.offsetTop, c = c == null ? void 0 : c.offsetParent;
        u == null || u.scrollTo({
          top: h - d,
          behavior: "smooth"
        });
      }
    },
    children: [
      /* @__PURE__ */ C("span", { title: t.text, children: t.text }),
      /* @__PURE__ */ C("div", { className: `${L}-catalog-wrapper`, children: t.children && t.children.map((o) => /* @__PURE__ */ C(
        $,
        {
          mdHeadingId: e,
          tocItem: o,
          scrollElement: s,
          onClick: n,
          scrollElementOffsetTop: d
        },
        `${o.text}-${o.index}`
      )) })
    ]
  }
), Z = $, q = (t) => {
  const {
    editorId: e,
    mdHeadingId: s = y.mdHeadingId,
    theme: n = "light",
    offsetTop: d = 20
  } = t, [o, l] = _([]), [i, u] = _(), c = P(() => {
    const a = [];
    return o.forEach((g, A) => {
      const { text: p, level: v } = g, r = {
        level: v,
        text: p,
        index: A + 1,
        active: i === g
      };
      if (a.length === 0)
        a.push(r);
      else {
        let f = a[a.length - 1];
        if (r.level > f.level)
          for (let m = f.level + 1; m <= 6; m++) {
            const { children: E } = f;
            if (!E) {
              f.children = [r];
              break;
            }
            if (f = E[E.length - 1], r.level <= f.level) {
              E.push(r);
              break;
            }
          }
        else
          a.push(r);
      }
    }), a;
  }, [i, o]), [h] = _(() => t.scrollElement || `#${e}-preview-wrapper`), R = M(() => h instanceof HTMLElement ? h : document.querySelector(h), [h]);
  return O(() => {
    let a = [];
    const g = D((r) => {
      if (r.length === 0)
        return l([]), !1;
      const { activeHead: f } = r.reduce(
        (m, E, x) => {
          const N = document.getElementById(
            s(E.text, E.level, x + 1)
          );
          if (N instanceof HTMLElement) {
            const w = R(), T = j(N, w);
            if (T < d && T > m.minTop)
              return {
                activeHead: E,
                minTop: T
              };
          }
          return m;
        },
        {
          activeHead: r[0],
          minTop: Number.MIN_SAFE_INTEGER
        }
      );
      u(f), l(r), a = r;
    });
    H.on(e, {
      name: S,
      callback: g
    });
    const A = R(), p = A === document.documentElement ? window : A;
    H.emit(e, U);
    const v = () => {
      g(a);
    };
    return p == null || p.addEventListener("scroll", v), () => {
      H.remove(e, S, g), p == null || p.removeEventListener("scroll", v);
    };
  }, [d, s, R]), /* @__PURE__ */ C(
    "div",
    {
      className: `${L}-catalog${n === "dark" ? "-dark" : ""} ${t.className || ""} `,
      style: t.style,
      children: c.map((a) => /* @__PURE__ */ C(
        Z,
        {
          mdHeadingId: s,
          tocItem: a,
          scrollElement: h,
          onClick: t.onClick,
          scrollElementOffsetTop: t.scrollElementOffsetTop
        },
        `${a.text}-${a.index}`
      ))
    }
  );
}, me = k.memo(q);
export {
  ce as B,
  Y as C,
  re as E,
  se as F,
  ne as H,
  me as M,
  Q as O,
  te as P,
  ie as R,
  le as T,
  de as U,
  oe as a,
  H as b,
  V as c,
  ae as d,
  ee as e,
  fe as f,
  ue as g,
  pe as h,
  he as i,
  Ee as j,
  S as k,
  U as l,
  ge as u
};
